export default __webpack_public_path__ + "static/choice-of-golang-e74ca0aadd1811ed785b1ba58462fd11.png";